'use client';

import { Box, Typography, TypographyProps, useMediaQuery } from '@mui/material';
import styled from '@emotion/styled';
import { useTranslations } from 'next-intl';
import { breakpoints, color, spacing } from '@/theme/tokens';

const Container = styled(Box)`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
`;

const Title = styled(Typography) <TypographyProps>`
    margin-bottom: ${spacing[8]};
    max-width: 600px;
    
    @media (max-width: ${breakpoints.sm}) {
        max-width: 312px !important;
    }
`;

const Message = styled(Typography) <TypographyProps>`
    max-width: 600px;
    white-space: pre-line;

    @media (max-width: ${breakpoints.sm}) {
        max-width: 312px !important;
    }
`;

interface NoResultsFoundProps {
    title?: string;
    message?: string;
}

const NoResultsFound = ({ title, message }: NoResultsFoundProps) => {
    const t = useTranslations('NoResultsFound');
    const isMobile = useMediaQuery(`(max-width: ${breakpoints.sm})`);

    return (
        <Container>
            <Title variant="heading2bold" sx={{ marginBottom: spacing[8] }}>{title || t('title')}</Title>
            {message ? (
                <Message component="div" variant="paragraph4regular">{message}</Message>
            ) : (
                <>
                    <Message component="div" variant="paragraph4regular">{isMobile ? t('messageMobile') : t('message')}</Message>
                    {!isMobile && <Message component="div" variant="paragraph4regular">{t('instruction')}</Message>}
                </>
            )}
        </Container>
    );
};

export default NoResultsFound;
